export const roles = Object.freeze({
    ADMIN: 4,
    COACH: 2,
    CLIENT: 1,
});

export const getRoleKeyByValue = (value) => {
  return Object.keys(roles).find((key) => roles[key] === value);
};